/** Deterministic hex color from a numeric stream id — stable across re-renders. */
export function stableStreamColor(streamId: number): string {
    const n = Math.abs(Math.trunc(streamId * 2654435761)) % 0xffffff;
    return `#${n.toString(16).padStart(6, "0")}`;
}
